import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgActionAiFix = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#88827E"
      d="m20.764 18.202 2.202 1.281-2.202 1.28-1.28 2.203-1.282-2.202L16 19.484l2.202-1.282L19.483 16l1.28 2.202ZM8.757 16.144l-5.582 5.582L1.76 20.31l5.582-5.582 1.414 1.415ZM14.414 2a7.073 7.073 0 0 1 3.91 1.179L14.12 7.156l.342 1.78 1.78.342 3.992-4.222a7.042 7.042 0 0 1 1.25 4.013A7.07 7.07 0 1 1 14.414 2Zm0 2a5.07 5.07 0 1 0 5.06 4.77l-2.535 2.68-4.186-.806-.806-4.186 2.597-2.456a5.18 5.18 0 0 0-.13-.002Z"
    />
  </svg>
);
export default SvgActionAiFix;
